import type { TVConfig } from '@nuxt/ui';
import type * as ui from '#build/ui';

export default {
    slots: {
        root: 'w-full',
    },
} satisfies TVConfig<typeof ui>['input'];
